import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Row, Col } from 'react-bootstrap'
import {
  customerContainer,
  nuskinSubscriptionContainer,
  multipleSubscriptionContainer,
} from 'src/models'
import { pageNames } from 'src/routes/pathParams'
import { IS_BROWSER } from 'config/appConfig'
import {
  i18nTranslate,
  getMysiteCartUrl,
  getShoppingContext,
  checkMysiteOrPersonalOffer,
} from 'src/utils'
import { isMultipleSubscriptionFlagEnabled } from 'src/deps'
import {
  isEquinoxMysite,
  buildPersonalOfferUrl,
  isEquinoxPOSite,
  getPersonalOfferRedirectUrl,
} from 'src/utils/mySiteUtils'
import './styles.scss'

/**
 * Handles navigation when the user is in a Personal Offer site context.
 *
 * `getPersonalOfferRedirectUrl` reconstructs the PO landing URL from the
 * locale prefix + resolved sponsor + sanitized pitch, so nested sub-routes
 * such as `/personal-offer/<sponsor>/expressCheckout` are dropped instead
 * of being carried over (which previously looped the user back to the cart).
 *
 * Returns true when navigation has been performed, false to allow the
 * caller to continue with default navigation logic.
 */
function navigateFromPoContext(history) {
  const poRedirectUrl = getPersonalOfferRedirectUrl()
  if (poRedirectUrl) {
    window.location.href = poRedirectUrl
    return true
  }

  const personalOfferUrl = buildPersonalOfferUrl()
  if (personalOfferUrl) {
    history?.push?.(personalOfferUrl)
    return true
  }

  return false
}

function NavigationButtons(props) {
  const buttonText =
    props?.buttonText ||
    i18nTranslate('cart.continueShopping', 'Continue Shopping')
  const history = useHistory()
  const [hasSubscriptions, setHasSubscriptions] = useState(false)
  const contextText = isEquinoxMysite()
    ? ''
    : checkMysiteOrPersonalOffer() || ''

  const handleSubscriptionNavigation = () => {
    history.push(pageNames.myaccountsubscriptions)
  }

  const handleHomeNavigation = () => {
    try {
      if (IS_BROWSER) {
        if (isEquinoxPOSite() && navigateFromPoContext(history)) {
          return
        }
        const shoppingContext = isEquinoxMysite() ? {} : getShoppingContext()
        if (Object.keys(shoppingContext).length > 0) {
          window.location.href = getMysiteCartUrl()
        } else {
          history?.push(pageNames.home)
        }
      }
    } catch (error) {
      console.error(
        'JSON.parse may be an error NavigationButtons.handleHomeNavigation ',
        error
      )
    }
  }

  useEffect(() => {
    if (
      customerContainer.isRegisterUser &&
      (nuskinSubscriptionContainer.hasSubscriptionPreference() ||
        (isMultipleSubscriptionFlagEnabled() &&
          multipleSubscriptionContainer.allSubscriptionListResponse
            ?.subscriptions?.length > 0))
    ) {
      setHasSubscriptions(true)
    }
  }, [])

  return (
    <Row className="d-flex justify-content-center mb-3">
      <Col
        className={`d-flex ${hasSubscriptions ? 'emptyCartButtonWrapper' : ''} ${
          props?.buttonCustomClassName || 'justify-content-md-end'
        }`}>
        <Button
          variant={props?.darkButtons ? 'primary' : 'outline-primary'}
          className="sub-btn"
          onClick={handleHomeNavigation}>
          {buttonText}
        </Button>
      </Col>
      {hasSubscriptions && contextText === '' && (
        <Col className="d-flex justify-content-center manage-subscriptions-button emptyCartButtonWrapper">
          <Button
            variant="primary"
            className="sub-btn"
            onClick={handleSubscriptionNavigation}>
            {i18nTranslate(
              'subscriptions.manageSubscriptionText',
              ' Manage Your Subscription'
            )}
          </Button>
        </Col>
      )}
    </Row>
  )
}

export { NavigationButtons }
export default NavigationButtons
